import React from "react";
import Modal from "./Modal";

export default function AuthRequiredModal({
    open,
    onClose,
    onLogin,
    title = "Нужна авторизация",
    message = "Записаться может только авторизованный пользователь.",
    loginLabel = "Авторизоваться",
}) {
    return (
        <Modal
            open={open}
            title={title}
            onClose={onClose}
            actions={
                <>
                    <button type="button" className="b-btn b-btn--primary" onClick={onLogin}>
                        {loginLabel}
                    </button>
                    <button type="button" className="b-btn b-btn--transparent" onClick={onClose}>
                        Позже
                    </button>
                </>
            }
        >
            <div className="b-modal__hint">{message}</div>
        </Modal>
    );
}
